export const trackingFilterMatcher = {
  destinationStopCount: "number_of_stops",
  originStopCount: "number_of_stops",
  departure_time_min: "departure_time",
  departure_time_max: "departure_time",
  return_time_min: "departure_time",
  return_time_max: "departure_time",
  airlines: "airline",
  originBaggages: "baggage_allowance",
  destinationBaggages: "baggage_allowance",
  flight_min_duration: "journey_duration",
  flight_max_duration: "journey_duration",
  visaTransits: "transit_visa",
  flight_stop_min: "stop_duration",
  flight_stop_max: "stop_duration",
  price_from: "price",
  price_to: "price",
  flightType: "ticket_type",
  filterCabinType: "ticket_class",
  originAirports: "airport",
  destinationAirports: "airport",
  originStopAirports: "stop_airport",
  destinationStopAirports: "stop_airport",
  arrival_time_min: "arrival_time",
  arrival_time_max: "arrival_time"
};
